// ... existing code ...

import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-charcoal-950 via-charcoal-900 to-charcoal-950 text-cream-100 relative overflow-hidden border-t border-gold-500/25">
      {/* Elementos decorativos dourados */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold-400/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Coluna 1 - Branding */}
          <div className="space-y-6">
            <div className="flex items-center gap-4">
              <img
                src="https://static.readdy.ai/image/9b313db6312c9605d9f9e3f145d3e29c/a68d70c6b66064870b0e9282c113321b.jpeg"
                alt="Bia Holmes"
                className="w-64 h-64 object-contain rounded-2xl bg-white p-1 flex-shrink-0"
              />
              <div>
                <div className="font-display font-semibold text-2xl tracking-wide text-cream-100">BIA HOLMES</div>
                <div className="text-sm font-medium text-gold-400 tracking-widest uppercase">
                  Empoderamento · PNL · Sucesso
                </div>
              </div>
            </div>
            <p className="text-charcoal-300 leading-relaxed text-base">
              Transforme sua vida com PNL, gratidão e técnicas de alta performance. Mais de 10.000 vidas já transformadas.
            </p>
            {/* Social */}
            <div className="flex gap-3">
              {[
                { icon: 'ri-instagram-fill', url: 'https://instagram.com' },
                { icon: 'ri-youtube-fill', url: 'https://youtube.com' },
                { icon: 'ri-linkedin-fill', url: 'https://linkedin.com' },
                { icon: 'ri-facebook-fill', url: 'https://facebook.com' },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gold-500/10 hover:bg-gold-500 border border-gold-500/30 hover:border-gold-400 rounded-lg flex items-center justify-center text-gold-400 hover:text-charcoal-900 text-lg transition-all duration-300"
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Coluna 2 - Método */}
          <div>
            <h4 className="font-display font-semibold text-lg mb-6 text-gold-400 tracking-wide flex items-center gap-2">
              <i className="ri-star-line text-xl"></i>
              Método
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Arsenal de PNL', path: '/planos' },
                { label: 'Ativações de Frequência', path: '/planos' },
                { label: 'Diário de Manifestação', path: '/planos' },
                { label: 'Comunidade Elite', path: '/comunidade' },
              ].map((item) => (
                <li key={item.path}>
                  <a
                    href={item.path}
                    className="text-charcoal-300 hover:text-gold-400 transition-colors flex items-center gap-2 group text-base"
                  >
                    <i className="ri-arrow-right-s-line text-gold-600 group-hover:translate-x-1 transition-transform"></i>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Coluna 3 - Recursos */}
          <div>
            <h4 className="font-display font-semibold text-lg mb-6 text-gold-400 tracking-wide flex items-center gap-2">
              <i className="ri-bookmark-line text-xl"></i>
              Recursos
            </h4>
            <ul className="space-y-3">
              {[
                { to: '/planos', label: 'Planos' },
                { to: '/exercicios-gratis', label: 'Exercícios Gratuitos', badge: { text: 'GRÁTIS', color: 'bg-emerald-700' } },
                { to: '/programa-diario', label: 'Programa Diário', badge: { text: 'NOVO', color: 'bg-gold-600' } },
                { to: '/diario', label: 'Diário Digital', badge: { text: 'NOVO', color: 'bg-green-700' } },
                { to: '/sobre', label: 'Sobre' },
                { to: '/blog', label: 'Blog' },
                { to: '/depoimentos', label: 'Depoimentos' },
                { to: '/imprensa', label: 'Imprensa' },
                { to: '/faq', label: 'FAQ' },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-charcoal-300 hover:text-gold-400 transition-colors flex items-center gap-2 text-base"
                  >
                    {item.label}
                    {item.badge && (
                      <span className={`text-xs ${item.badge.color} text-cream-50 px-2 py-0.5 rounded-full font-medium`}>
                        {item.badge.text}
                      </span>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Coluna 4 - Contato */}
          <div>
            <h4 className="font-display font-semibold text-lg mb-6 text-gold-400 tracking-wide flex items-center gap-2">
              <i className="ri-mail-line text-xl"></i>
              Contato
            </h4>
            <ul className="space-y-4 mb-6">
              <li className="flex items-start gap-3 text-charcoal-300 text-base">
                <i className="ri-mail-line text-gold-500 text-xl mt-1"></i>
                <a href="mailto:contato@biaholmes.com" className="hover:text-gold-400 transition-colors">
                  contato@biaholmes.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-charcoal-300 text-base">
                <i className="ri-whatsapp-line text-gold-500 text-xl mt-1"></i>
                <a href="https://wa.me/5511999999999" className="hover:text-gold-400 transition-colors">
                  (11) 99999-9999
                </a>
              </li>
              <li className="flex items-start gap-3 text-charcoal-300 text-base">
                <i className="ri-map-pin-line text-gold-500 text-xl mt-1"></i>
                <span>São Paulo, SP — Brasil</span>
              </li>
            </ul>

            {/* Newsletter */}
            <div className="bg-gold-500/8 border border-gold-500/25 p-5 rounded-xl">
              <h5 className="font-display font-semibold text-base mb-2 text-gold-400 flex items-center gap-2">
                <i className="ri-sparkling-2-line text-lg"></i>
                Conteúdo Exclusivo
              </h5>
              <p className="text-charcoal-400 text-sm mb-4">
                Receba dicas semanais de PNL e transformação
              </p>
              <form className="flex gap-2">
                <input
                  type="email"
                  placeholder="Seu email"
                  className="flex-1 px-4 py-2.5 bg-charcoal-800 border border-gold-500/25 rounded-lg text-cream-100 placeholder-charcoal-400 focus:outline-none focus:border-gold-500 text-sm"
                />
                <button
                  type="submit"
                  className="bg-gradient-to-r from-gold-600 to-gold-500 hover:from-gold-700 hover:to-gold-600 text-cream-50 px-4 py-2.5 rounded-lg font-semibold transition-all duration-300 shadow-gold hover:shadow-gold-lg whitespace-nowrap"
                >
                  <i className="ri-send-plane-fill text-lg"></i>
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Divisor */}
        <div className="border-t border-gold-500/20 mb-8"></div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-charcoal-400 text-sm">
            © {currentYear} <span className="text-gold-400 font-semibold">Bia Holmes</span>. Todos os direitos reservados.
          </div>
          <div className="flex flex-wrap gap-6">
            {[
              { to: '/termos', label: 'Termos de Uso' },
              { to: '/privacidade', label: 'Privacidade' },
              { to: '/mapa-do-site', label: 'Mapa do Site' },
            ].map((item) => (
              <Link key={item.to} to={item.to} className="text-charcoal-400 hover:text-gold-400 transition-colors text-sm">
                {item.label}
              </Link>
            ))}
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-charcoal-400 hover:text-gold-400 transition-colors text-sm">
              Powered by Readdy
            </a>
          </div>
        </div>

        {/* Badges de segurança */}
        <div className="flex flex-wrap justify-center gap-4 mt-8 pt-8 border-t border-gold-500/10">
          {[
            { icon: 'ri-shield-check-fill', text: 'Pagamento Seguro' },
            { icon: 'ri-lock-fill', text: 'Dados Protegidos' },
            { icon: 'ri-customer-service-fill', text: 'Suporte 24/7' },
            { icon: 'ri-medal-fill', text: 'Garantia 7 Dias' },
          ].map((badge, index) => (
            <div
              key={index}
              className="flex items-center gap-2 text-charcoal-400 bg-gold-500/5 border border-gold-500/15 px-4 py-2 rounded-lg hover:border-gold-500/30 hover:text-gold-400 transition-all text-sm"
            >
              <i className={`${badge.icon} text-gold-500 text-base`}></i>
              <span className="font-medium">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
}
